import { forwardRef } from 'react'
import { accents } from 'sutra/tokens/colors'

export interface CheckboxListOptionProps {
  label: string
  prefix?: string
  subtitle?: string
  isSelected: boolean
  isHighlighted?: boolean
  isDisabled?: boolean
  disabledReason?: string
  onClick: () => void
}

export const CheckboxListOption = forwardRef<
  HTMLDivElement,
  CheckboxListOptionProps
>(
  (
    {
      label,
      prefix,
      subtitle,
      isSelected,
      isHighlighted = false,
      isDisabled = false,
      disabledReason,
      onClick,
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        onClick={isDisabled ? undefined : onClick}
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '8px',
          cursor: isDisabled ? 'not-allowed' : 'pointer',
          borderRadius: '6px',
          backgroundColor: isDisabled
            ? '#f3f4f6'
            : isHighlighted
              ? accents.reflectionBlue[100]
              : isSelected
                ? accents.reflectionBlue[50]
                : 'transparent',
          border: isDisabled
            ? '1px solid transparent'
            : isSelected
              ? `1px solid ${accents.reflectionBlue[500]}`
              : '1px solid transparent',
          marginBottom: '4px',
          transition: 'all 0.2s ease',
          opacity: isDisabled ? 0.6 : 1,
        }}
        onMouseEnter={(e) => {
          if (!isSelected && !isDisabled && !isHighlighted) {
            e.currentTarget.style.backgroundColor = accents.reflectionBlue[100]
          }
        }}
        onMouseLeave={(e) => {
          if (!isSelected && !isDisabled && !isHighlighted) {
            e.currentTarget.style.backgroundColor = 'transparent'
          }
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              width: '16px',
              height: '16px',
              borderRadius: '3px',
              border: '2px solid',
              borderColor: isDisabled
                ? '#d1d5db'
                : isSelected
                  ? accents.reflectionBlue[500]
                  : '#d1d5db',
              backgroundColor: isDisabled
                ? 'transparent'
                : isSelected
                  ? accents.reflectionBlue[500]
                  : 'transparent',
              marginRight: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            {isSelected && !isDisabled && (
              <svg
                width="10"
                height="10"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 6L5 9L10 3"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </div>

          <div style={{ flex: 1 }}>
            <div
              style={{
                fontSize: '13px',
                fontWeight: isDisabled ? '400' : isSelected ? '600' : '400',
                color: isDisabled
                  ? '#9ca3af'
                  : isSelected
                    ? '#1f2937'
                    : '#374151',
              }}
            >
              {prefix && (
                <span style={{ color: '#9ca3af', fontWeight: '400' }}>
                  {prefix} {'> '}
                </span>
              )}
              {label}
            </div>
            {subtitle && (
              <div
                style={{
                  fontSize: '11px',
                  color: '#9ca3af',
                  marginTop: '2px',
                }}
              >
                {subtitle}
              </div>
            )}
          </div>
        </div>

        {isDisabled && disabledReason && (
          <div
            style={{
              marginTop: '4px',
              fontSize: '11px',
              color: '#9ca3af',
              fontStyle: 'italic',
            }}
          >
            {disabledReason}
          </div>
        )}
      </div>
    )
  },
)

CheckboxListOption.displayName = 'CheckboxListOption'
